import { BRANDS } from '../constants/brandNames.contants';
import { TBrand } from '../types/types';
import useSitecoreContext from './useSitecoreContext';

const useBrandName = (): TBrand => {
  const { sitecoreContext } = useSitecoreContext();

  return sitecoreContext.brand === BRANDS.NEW_HOLLAND ? BRANDS.NEW_HOLLAND : BRANDS.CASE;
};

export default useBrandName;
